import React, { Component } from 'react';
import '../../components/css/popupstyle.css';
import $ from 'jquery';

class ReportPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
        };       
    }
    componentDidMount() {
        $('body').addClass('tier');
    }
    componentWillUnmount() {
        $('body').removeClass('tier');
    }
    render() {
        return (
            <div className='popup'>
                <div className='popup_inner rep'>

                    <h1>{this.props.titleText}<button onClick={this.props.closeMilestonePopup}>X</button></h1>

                    <div className="campaign">

                        <div class="range">
                            <span className="info"><img className="tier-icon" src={this.props.tierDetails[0].tierIconUrl} alt="icon" />{this.props.tierDetails[0].tierName}</span>
                            <span className="bar"><span className="green-bar" style={this.props.tierDetails[0].styleWidth}><span style={this.props.tierDetails[0].stylePosition} className="green-tooltip">{this.props.tierDetails[0].cTransition > 1 ? this.props.tierDetails[0].cTransition + ' Transactions' : this.props.tierDetails[0].cTransition + ' Transaction'}<span style={this.props.tierDetails[0].styleAngle} className="angle">&nbsp;</span></span></span></span>
                            <span className="min">{this.props.tierDetails[0].tierFrom}</span><span className="max">{this.props.tierDetails[0].tierTo}</span>
                            {
                                this.props.tierDetails[0].tierName != this.props.tierDetails[0].lastTierName ?
                                    <span className="remain">{this.props.tierDetails[0].nMilestonePoints} {this.props.tierDetails[0].nMilestonePoints > 1 ? 'transactions' : 'transaction'} to reach the next level</span>
                                    : null
                            }
                        </div>
                        <div className="text">
                            <p>The RxHacker RockStar Revenue Program gives you the opportunity to scale up your commission earnings as you produce more claims! The table below provides all of the details.</p>
                        </div>

                        <h2>How it works</h2>

                        <div className="tier">
                            <div className="heading">
                                <span className="column1">Tier Name</span>
                                <span className="column2">No. of transaction</span>
                                <span className="column3">Commission ($)</span>
                            </div>
                            <ul>
                                {
                                    this.props.tierDetails[0].tierJson.map((item, index) => {
                                        return (
                                            <li>
                                                <span className="column1">
                                                    <img className="tier-icon" src={item.tierIcon} alt="icon" />
                                                    <span className="name">{item.tierName}</span>
                                                </span>
                                                {
                                                    (this.props.tierDetails[0].tierJson.length - 1) == index ?
                                                    <span className="column2">{item.from + ' + '}</span> :
                                                    <span className="column2">{item.from + ' - ' + item.to}</span>
                                                }
                                                <span className="column3">{'$'+item.commission}</span>
                                            </li>                                            
                                          )
                                    })
                                }
                            </ul>
                        </div>


                    </div>
                </div>
            </div>
        );
    }
}
export default ReportPopup;
